export const LMT_ENHCMT_updateJourneyTypeEnumReducer = {
  LMT_ENHCMT_updateJourneyTypeEnum: (state, action) => {
    state.journeyTypeEnum = action.payload;
  },
};
